module.exports = __webpack_public_path__ + "img/stock4.fd8d3876.png";